import { render, staticRenderFns } from "./Clinico.vue?vue&type=template&id=1eb18d42&"
import script from "./Clinico.vue?vue&type=script&lang=js&"
export * from "./Clinico.vue?vue&type=script&lang=js&"
import style0 from "./Clinico.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports